import { createPriceDtoFromAdminPriceModel, PriceModel } from "./price";
import { B2bMarketPriceDto } from "@vini-wine/core-dtos";

export interface B2bMarketPriceModel {
  // default includes
  price: PriceModel | null;

  // transform
  updatedAt: Date;
}

export const createB2BMarketPriceDtoFromAdminB2BMarketPriceModel = (
  b2bMarketPrice: B2bMarketPriceModel,
): B2bMarketPriceDto => {
  return {
    price: b2bMarketPrice.price
      ? createPriceDtoFromAdminPriceModel(b2bMarketPrice.price)
      : null,
    updatedAt: b2bMarketPrice.updatedAt,
  };
};
